"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, Lightbulb } from "lucide-react";
export default function CareerInsightsHero() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="258912" id="מטפל-סיעודי-בהרצליה-פתרון-מיידי" className="relative overflow-hidden bg-background py-24 md:py-32 lg:py-40">
            {}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                {}
                <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[70%] rounded-lg bg-secondary/5 blur-[100px] transform rotate-12" />
                {}
                <div className="absolute -bottom-[20%] -right-[10%] w-[60%] h-[80%] rounded-lg bg-accent/20 blur-[120px] transform -rotate-12" />
                {}
                <div className="absolute top-[20%] left-[20%] w-[60%] h-[60%] border border-primary/5 rounded-lg transform -skew-x-12 opacity-50" />
            </div>

            <div className="container mx-auto px-4 md:px-6 relative z-10">
                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3 flex flex-col items-center text-center">
                        <div ref={headerRef} className={`transition-all duration-1000 ease-out ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
                            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-primary/10 text-primary text-sm font-default mb-8 shadow-sm">
                                <Lightbulb className="size-4" />
                                <span>זמינות מיידית 24/7</span>
                            </div>
                            <h1 className="font-default text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground tracking-tight mb-6 leading-[1.1]">
                                מטפל סיעודי בהרצליה <br className="hidden md:block" />
                                <span className="text-primary">תוך 5 שעות בלבד</span>
                            </h1>
                        </div>

                        <div ref={contentRef} className={`transition-all duration-1000 delay-300 ease-out flex flex-col items-center ${isContentVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
                            <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-[640px] font-default leading-relaxed">
                                זקוקים לעזרה דחופה? אנו מספקים שירותי סיעוד מקצועיים בהרצליה והסביבה. צוות המטפלים שלנו ערוך להגעה מהירה למתן סיוע אישי ומסור בביתכם או בבית החולים.
                            </p>

                            <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
                                <Button size="lg" className="w-full sm:w-auto h-12 px-8 text-base rounded-md shadow-md bg-primary text-primary-foreground hover:bg-primary/90 font-default" asChild>
                                    <Link to="/NursingCareNowPage">
                                        מטפל סיעודי בבית
                                        <ArrowRight className="mr-2 size-4 rotate-180" />
                                    </Link>
                                </Button>
                                <Button size="lg" variant="outline" className="w-full sm:w-auto h-12 px-8 text-base rounded-md bg-background/50 backdrop-blur-sm shadow-sm border-primary/20 text-primary font-default" asChild>
                                    <Link to="/NursingCareProviderInHerzliyaWithinFiveHoursPage">
                                        השגחה בבית חולים
                                    </Link>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
}